import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
import type { GuideStep } from '../data/guideSteps';
interface GuideStepSectionProps {
  step: GuideStep;
  flip: boolean;
  mono: boolean;
}
export function GuideStepSection({
  step,
  flip,
  mono
}: GuideStepSectionProps) {
  return <section id={step.id} aria-labelledby={`${step.id}-title`} className="scroll-mt-24 border-t border-ink/10 py-16 first:border-t-0 lg:py-24" data-id="element-37" data-mp="1tsxbi8b7imc2">
      <div className="grid items-center gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-38" data-mp="w6ztec0qoj0n">
        <div className={flip ? 'lg:col-span-5 lg:order-2' : 'lg:col-span-5'} data-id="element-39" data-mp="1151airelu89h">
          <span className="block text-5xl font-extrabold tabular-nums text-ink/15 lg:text-6xl" data-id="element-40" data-mp="16331dyi9vbvi">
            {step.number}
          </span>
          <h2 id={`${step.id}-title`} className="mt-3 text-3xl font-bold tracking-tight text-ink lg:text-4xl" data-id="element-41" data-mp="1b3qucpq2a2sd">
            {step.title}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-42" data-mp="2mg1bfyvg0agz">{step.body}</p>

          {step.callout && <div className="mt-7 rounded-2xl bg-white p-5 ring-1 ring-ink/10" data-id="element-43" data-mp="1b8dzekc41xcx">
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-44" data-mp="16bdtc9f9gult">
                {step.callout.label}
              </p>
              {step.callout.href ? <a href={step.callout.href} className="mt-2 inline-flex items-center gap-2 break-all text-base font-semibold text-brand underline-offset-4 transition-colors duration-150 ease-smooth hover:text-brand-dark hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand" data-id="element-45" data-mp="x8coec24t9jq">
                  {step.callout.text}
                  <ExternalLinkIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-46" data-mp="ekr5at2ier2n" />
                </a> : <p className="mt-2 text-base leading-relaxed text-ink" data-id="element-47" data-mp="4l8r6t9a5zii">
                  {step.callout.text}
                </p>}
            </div>}

          {step.note && <p className="mt-5 text-sm leading-relaxed text-muted" data-id="element-48" data-mp="3w36iea8zuvl4">{step.note}</p>}
        </div>

        <div className={flip ? 'lg:col-span-7 lg:order-1' : 'lg:col-span-7'} data-id="element-49" data-mp="3h65r27upt2n6">
          <figure className="rounded-3xl bg-white p-2.5 ring-1 ring-ink/10" data-id="element-50" data-mp="3m478kochstwj">
            <img src={step.image} alt={step.imageAlt} loading="lazy" className={['w-full rounded-2xl', mono ? 'grayscale' : ''].join(' ')} data-id="element-51" data-mp="dncfg0lhynvn" />
          </figure>
        </div>
      </div>
    </section>;
}